import { render, staticRenderFns } from "./Negociation.vue?vue&type=template&id=71f123ac&scoped=true"
import script from "./Negociation.vue?vue&type=script&lang=js"
export * from "./Negociation.vue?vue&type=script&lang=js"
import style0 from "./Negociation.vue?vue&type=style&index=0&id=71f123ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f123ac",
  null
  
)

export default component.exports